import { INFRACTION_AIT_LENGTH } from "../constants/infraction-create.constant";

const INFRACTION_AIT_ALLOWED_CHARS_REGEX = /[^A-Z0-9]/g;

/**
 * Sanitiza o código do auto (AIT): apenas A-Z e 0-9, em maiúsculas.
 */
export function sanitizeInfractionAit(
	value: string,
	isAnttInfraction = false
): string {
	const maxLength = isAnttInfraction
		? INFRACTION_AIT_LENGTH.ANTT
		: INFRACTION_AIT_LENGTH.STANDARD;

	return value
		.toUpperCase()
		.replace(INFRACTION_AIT_ALLOWED_CHARS_REGEX, "")
		.slice(0, maxLength);
}
